

/**
 * The function Layout returns its children.
 * @returns The "children" prop is being returned.
 */
export default function Layout({ children }) {
  return children;

}